// extracted by mini-css-extract-plugin
export default {"downContainer":"ScrollButton_downContainer__cLHet","arrowButton":"ScrollButton_arrowButton__sRjQb","downText":"ScrollButton_downText__oMwM3"};